(() => {
  if (window.__azNutritionLightboxLoaded) return;
  window.__azNutritionLightboxLoaded = true;

  let lastTrigger = null;

  const getDialogForTrigger = (trigger) => {
    const root = trigger.closest('[data-tabbed-group]');
    return root?.querySelector('[data-nutrition-lightbox]') || document.querySelector('[data-nutrition-lightbox]');
  };

  const lockPage = () => document.documentElement.classList.add('nutrition-lightbox-open');
  const unlockPage = () => document.documentElement.classList.remove('nutrition-lightbox-open');

  const openDialog = (dialog, trigger) => {
    if (!dialog) return;
    lastTrigger = trigger || document.activeElement;

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.classList.add('is-fallback-open');
    }

    lockPage();
    loadComparison(dialog);
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.classList.remove('is-fallback-open');
    }

    unlockPage();

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      window.requestAnimationFrame(() => lastTrigger.focus({ preventScroll: true }));
    }
  };

  const buildFetchUrl = (source) => {
    const url = new URL(source, window.location.origin);
    const current = new URL(window.location.href);

    // Preserve Shopify preview parameters while working in an unpublished theme.
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.searchParams.has(key) && !url.searchParams.has(key)) {
        url.searchParams.set(key, current.searchParams.get(key));
      }
    });

    return url.toString();
  };

  const renderError = (dialog, error) => {
    const body = dialog.querySelector('[data-nutrition-lightbox-body]');
    if (!body) return;

    body.removeAttribute('aria-busy');
    body.replaceChildren();

    const wrapper = document.createElement('div');
    wrapper.className = 'nutritionLightbox__error';

    const message = document.createElement('p');
    message.textContent = 'We couldn’t load the comparison inside the lightbox. You can still view the full Nutritional Info page.';

    const link = document.createElement('a');
    link.href = dialog.dataset.sourceUrl || '/pages/nutritional-info';
    link.textContent = 'Visit Nutritional Info page';

    wrapper.append(message, link);
    body.append(wrapper);

    if (window.console && console.warn) {
      console.warn('[Amino Z] Nutritional Info lightbox:', error);
    }
  };

  const loadComparison = async (dialog) => {
    if (dialog.dataset.loaded === 'true' || dialog.dataset.loading === 'true') return;

    const body = dialog.querySelector('[data-nutrition-lightbox-body]');
    const sourceUrl = dialog.dataset.sourceUrl;
    if (!body || !sourceUrl) return;

    dialog.dataset.loading = 'true';
    body.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(buildFetchUrl(sourceUrl), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const sourceSection = parsed.querySelector('[data-nutrition-comparison]');

      if (!sourceSection) {
        throw new Error('Nutritional comparison section was not found on the configured page.');
      }

      const importedSection = document.importNode(sourceSection, true);
      importedSection.setAttribute('data-modal-context', '');

      body.replaceChildren(importedSection);
      body.removeAttribute('aria-busy');
      dialog.dataset.loaded = 'true';

      // nutritional-comparison.js listens for this Shopify event. Dispatch from
      // the wrapper so its init() sees the newly inserted comparison component.
      body.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    } catch (error) {
      renderError(dialog, error);
    } finally {
      delete dialog.dataset.loading;
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-nutrition-lightbox-trigger]');
    if (trigger) {
      const dialog = getDialogForTrigger(trigger);
      if (!dialog) return; // If JS/dialog is unavailable, the normal page link still works.

      event.preventDefault();
      openDialog(dialog, trigger);
      return;
    }

    const close = event.target.closest('[data-nutrition-lightbox-close]');
    if (close) {
      event.preventDefault();
      closeDialog(close.closest('[data-nutrition-lightbox]'));
      return;
    }

    const dialog = event.target.closest('[data-nutrition-lightbox]');
    if (dialog && event.target === dialog) {
      closeDialog(dialog);
    }
  });

  document.addEventListener('cancel', (event) => {
    const dialog = event.target.closest?.('[data-nutrition-lightbox]');
    if (!dialog) return;
    event.preventDefault();
    closeDialog(dialog);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const fallback = document.querySelector('[data-nutrition-lightbox].is-fallback-open');
    if (fallback) closeDialog(fallback);
  });
})();